import { Popover, Transition } from '@headlessui/react';
import type { ComponentProps } from 'react';
import { Fragment } from 'react';

import { Button } from '~modules/media-library/view/Button';
import { FilterSelectPanel } from '~modules/media-library/view/FilterSelect/FilterSelectPanel';

type PopoverButtonProps = { label: string; active?: boolean };
function PopoverButton({ label, active }: PopoverButtonProps) {
  return (
    <Popover.Button as={Button} variant="link" className={active && 'opacity-50 hover:opacity-100'}>
      {label}
    </Popover.Button>
  );
}

type PanelProps = Pick<
  ComponentProps<typeof FilterSelectPanel>,
  'filterList' | 'activeFilterIds' | 'onChangeActiveFilterIds' | 'labelAction'
>;
function Panel(props: PanelProps) {
  return (
    <Transition
      as={Fragment}
      enter="transition ease-out duration-100"
      enterFrom="transform opacity-0 scale-95"
      enterTo="transform opacity-100 scale-100"
      leave="transition ease-in duration-75"
      leaveFrom="transform opacity-100 scale-100"
      leaveTo="transform opacity-0 scale-95"
    >
      <Popover.Panel className="absolute right-0 mt-2 min-w-52 w-full origin-top-right outline-none z-30">
        {({ close }) => <FilterSelectPanel {...props} onActionClick={close} />}
      </Popover.Panel>
    </Transition>
  );
}

function FilterSelectRoot({ children }: { children: any }) {
  return <Popover>{children}</Popover>;
}

export const FilterSelect = Object.assign(FilterSelectRoot, { Button: PopoverButton, Panel });
